module.exports = __webpack_public_path__ + "img/website.27c0aebc.svg";